import { closeSubmenus } from './menu';
var initSearchBar = function initSearchBar() {
  var openSearchBar = document.querySelector('.searchbar-js-open');
  var closeSearchBar = document.querySelector('.searchbar-js-close');
  var searchBar = document.querySelector('.searchbar-js');
  openSearchBar.addEventListener('click', function () {
    searchBar.classList.toggle('opened');
    openSearchBar.classList.toggle('active');
    closeSubmenus();
  });
  closeSearchBar.addEventListener('click', function () {
    searchBar.classList.remove('opened');
    openSearchBar.classList.toggle('active');
  });
};
export { initSearchBar };